<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Components
	import VirtualDeviceDrawer from '../../VirtualDeviceDrawer.svelte';
	import DrawerStatusBar from 'src/components/Drawer/DrawerStatusBar.svelte';
	import VirtualDeviceDrawerV2 from 'src/components/Sidepanel/SidePanelLayoutProvider/SidePanelDeviceLayout/Devices/Virtual/virtual-group/VirtualDeviceDrawerV2.svelte';
	//Design System
	import { DrawerTab, DrawerTabs, DrawerTabContent, Text } from '@Shelly/shelly-design-system/index';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Helpers
		import { getDeviceStatus, getDeviceSettings, readDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { real_id } from 'src/helpers/interface_helpers';
	import { getVComponentStatus } from 'src/helpers/virtual_helpers/virtual_components_status_helpers';
	import { buildDrawerTabItems } from 'src/helpers/virtual_helpers/template_helpers/virtual_template_preview_helpers';
	//Types
	import type { Device } from 'src/types/Device';
	import type { VirtualDeviceTemplate } from 'src/helpers/virtual_helpers/template_helpers/virtual_template_types';
	import type { VCInterfaceStatus } from 'src/types/VirtualComponents';
	import type { DeviceStatusG2 } from 'src/types/DeviceStatusG2';

	$: statusStore = getDeviceStatus(device.id);
	export let device: Device;
	export let virtualTemplate: VirtualDeviceTemplate;
	export let templateName: string;

	const drawerTabItems = buildDrawerTabItems(device);
	const buildPreview = (_trigger: DeviceStatusG2) => {
		return getVComponentStatus(device, null, null, false, virtualTemplate);
	};

	let statuses: VCInterfaceStatus[] | null = null;
	$: {
		const trigger = device?.id ? $statusStore : null;
		statuses = device?.id ? buildPreview(trigger) : null;
	}
</script>

<div class="preview-box">
	<div class="preview-box-content background-color-0">
		{#if $showNewLayout}
			{#if statuses}
				<div class="preview-box-content-inner-v2">
					<Text
						element="p"
						styleType="body-small"
						class="mb-m text-center text-bold controls-large-styles text-nowrap"
						>{templateName}</Text
					>
					<div class="template-preview-content">
						<VirtualDeviceDrawerV2
							{device}
							{statuses}
							{virtualTemplate}
							enableValidationSettingsLinks={false}
						/>
					</div>
				</div>
			{/if}
		{:else}
			<div class="preview-box-content-inner">
				<div class="preview-box-status-bar">
					<DrawerStatusBar />
				</div>
				<DrawerTabs backgroundImgSrc="">
					<svelte:fragment slot="tabs">
						{#each drawerTabItems as drawerTab, index}
							<DrawerTab
								icon={drawerTab?.icon}
								image={drawerTab?.image}
								disabled={index > 0}
								active={index === 0}
							/>
						{/each}
					</svelte:fragment>
					<DrawerTabContent
						heading={templateName}
						subHeading={$format('settings_title_main_controls', {
							default: 'Main controls',
						})}
					>
						{#if statuses}
							<VirtualDeviceDrawer
								{device}
								{statuses}
								{virtualTemplate}
								enableValidationSettingsLinks={false}
							/>
						{/if}
					</DrawerTabContent>
				</DrawerTabs>
			</div>
		{/if}
	</div>
</div>

<style>
	.preview-box {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.preview-box-content {
		width: 100%;
		height: 100%;
		max-width: 360px;
		min-width: 320px;
		display: block;
	}
	.preview-box-content-inner {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
		padding: 8px;
		border: 1px solid var(--color-3);
		border-top-left-radius: var(--radius-big);
		border-bottom-left-radius: var(--radius-big);
		background: var(--color-1);
	}
	.preview-box-content-inner-v2 {
		display: flex;
		flex-direction: column;
		padding: 16px 12px 10px;
		border: 1px solid var(--color-2);
		border-radius: var(--radius-extra-big);
		background: var(--color-base);
	}
	.template-preview-content {
		display: flex;
		flex-direction: column;
		width: 100%;
		min-width: 0;
	}
	.template-preview-content > * {
		width: 100%;
		min-width: 0;
		flex: 0 0 auto;
	}
	.preview-box-status-bar {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		margin-top: -4px;
		margin-bottom: 4px;
		min-height: 20px;
	}
	.preview-box :global(.drawer-tabs) {
		height: auto;
	}
</style>
